import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaPencilAlt } from "react-icons/fa";
import ConfirmModal from "../utils/ConfirmModal";
import { hasPermission } from "../utils/usePermission";
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";
export default class VendorWorkOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendorWorkOrders: [],
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: "",
      deleteId: null,
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchVendorWorkOrders();
  }

  fetchVendorWorkOrders = () => {
    this.setState({ loading: true });
    axios
      .get("/vendorWorkOrders")
      .then((res) => {
        this.setState({ vendorWorkOrders: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching vendor work orders",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    // this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .delete(`/vendorWorkOrders/${this.state.deleteId}`, { headers: { Authorization: `Bearer ${token} ` } })
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: "Vendor Work Order deleted successfully",
          toastVariant: "success",
          deleteId: null,
          color: 'green',
          showConfirm: false,
        });
        this.fetchVendorWorkOrders();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting vendor work order",
          color: 'red',
          showConfirm: false,
          deleteId: null,
        });
      });
  };

  handleEdit = (rowData) => {
    const { id } = rowData;
    this.props.history.push(`/vendorWorkOrder-edit/${id}`, { data: rowData });
  };

  handleMoveAdd = () => {
    this.props.history.push('/add-vendor-work-order')
  }


  handleView = (rowData) => {
    // console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/vendor-work-order-view/${id}`, { data: rowData });
  };


  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    const { vendorWorkOrders, loading, showToast, toastMessage, color, toastVariant } = this.state;
    return (
      <>
        <CommonToast
          show={showToast}
          onClose={() => this.setState({ showToast: false })}
          message={toastMessage}
          variant={toastVariant}
          color={color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={loading}
          message="Are you sure you want to delete this Vendor Work Order?"
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M20B1') && (
                  <div className='add-role'>
                    <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleMoveAdd}> <i className="fa fa-plus-circle"></i> Add Vendor Work Order</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Vendor Work Order List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Vendor Work Orders"
                      columns={[
                        { title: "ID", field: "id", editable: "never" },
                        { title: "WO Number", field: "woNumber" },
                        {
                          title: "WO Date", field: "woDate", type: "date",
                          render: (value) => DateTimeFormat(value.woDate),
                        },
                        {
                          title: "Vendor Name",
                          field: "vendor.name",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData => rowData?.vendor?.name || "-"
                        },
                        {
                          title: "Project Name",
                          field: "project.name",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData => rowData?.project?.name || "-"
                        },
                        {
                          title: "Customer Name",
                          field: "customer.name",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData => rowData?.customer?.name || "-"
                        },
                        {
                          title: "Dispatch Address",
                          field: "dispatchAddress.address",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 },
                          render: rowData =>
                            rowData?.dispatchAddress
                              ? `${rowData.dispatchAddress.address}, ${rowData.dispatchAddress.city}`
                              : "-"
                        },
                        {
                          title: "Status", field: "status",
                          render: rowData => {
                            const status = rowData?.status;
                            const baseStyle = {
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.875rem',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontWeight: 500
                            };
                            if (status === 'draft') {
                              return <span style={{
                                ...baseStyle,
                                backgroundColor: '#f8d7da',
                                color: '#842029',
                                border: '1px solid #f5c2c7'
                              }}>
                                <FaPencilAlt /> Draft
                              </span>;
                            }
                          }
                        },
                        {
                          title: "Total Item Value ", field: "status",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 },
                          render: rowData => {
                            const totalValue = (rowData.items || []).reduce((sum, item) => {
                              return sum + (parseFloat(item.totalValue) || 0);
                            }, 0);

                            return `₹ ${totalValue.toFixed(2)}`;
                          }
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {hasPermission('M20B2') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-edit-${rowData?.id}`}>Edit Vendor Work Order</Tooltip>}
                                >
                                  <Button
                                    size="sm"
                                    variant="outline-info"
                                    className="mr-2 info"
                                    onClick={() => this.handleEdit(rowData)}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M20B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData?.id}`}>Delete Vendor Work Order</Tooltip>}
                                >
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    className="mr-2 delete-btn"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M20B4') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>View  Vendor Work Order</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleView(rowData)}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}

                            </>
                          ),
                          cellStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }, // Adjust width as needed
                          headerStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }
                        }
                      ]}
                      data={vendorWorkOrders}
                      options={{
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        pageSize: 10,
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body >
              </Card >
            </div >
          </div >
        </CommonLoader >
      </>
    );
  }
}
